import { getValue } from '@/utils/utils.js'
const state = {
  sb3: getValue('sb3'), // 直接加载源码
  role: getValue('role'), // 角色 1：学生 ，2：教师 3：机构  4：公开
  isApp: getValue('isApp'), // 是否是App端
  isSb3: getValue('isSb3'), // 是否加载源码  1: 加载源码 2： 加载答案
  isMp4: getValue('isMp4'), // 显示视频弹窗
  isTask: getValue('isTask'), //是否显示任务列表弹窗
  showMind: getValue('showMind'),// 是否显示思维导图
  isMind: getValue('isMind'), // 是否弹出思维导图弹框
  token: getValue('token'), // token
  bookSubId: getValue('bookSubId'), // 小节ID
  tenantApi: getValue('tenantApi'), // 基础请求接口地址
  loginUrl: getValue('loginUrl') , // 登录过期时需要返回的地址
  classId: getValue('classId'), // 班级id
  result: getValue('result'), // 是否是自由创作
  resultId: getValue('resultId'), // 作品ID
  title: getValue('title',''), // 标题
  startTime: new Date().getTime(),
  isExam: getValue('isExam'), // 是否考试
  examId: getValue('examId'), // 试卷ID 
  examSubjectId: getValue('examSubjectId'),
  domain: getValue('domain'),
  isJob: getValue('isJob'),
  jobId: getValue('jobId')
}

const mutations = {
  // SET_BUSINESS_ID: (state, businessId) => {
  //   state.businessId = businessId
  //   set('businessId', businessId)
  // }
  setClassId(state,classId){
    state.classId = classId
  }
}

const actions = {

  // // 退出登录
  // logout({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     commit('SET_TOKEN', '')
  //     commit('SET_ROLES', [])
  //     removeToken()
  //     resetRouter()
  //     resolve()
  //   })
  // },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/info.js